import { capitalize, isNil } from "lodash";
import { getAccountType, getPartialAccountNumber, isManualAccount, MASK_NUMBER, UNKNOWN_ACCOUNT, } from "../api/Accounts/utilities/accountUtil";
const isManualAccountV1 = (acc) => {
    return "accountProvider" in acc && acc.accountProvider === "manual";
};
const isPlaidAccountExtended = (acc) => {
    return ("accountProvider" in acc && acc.accountProvider === "plaid" && "link" in acc);
};
const isExtendedAccount = (account) => {
    return ("accountProvider" in account &&
        (account.accountProvider === "Manual" ||
            account.accountProvider === "Plaid"));
};
/**,
 * Format an AccountDetail object into a single line readable format.
 * @param {MiniAccountDetails} account - The account to format.
 * @return {string} The readable format. ex: <Account Name> (<Custodian ID>)
 */
export const formatFartherAccount = (account, isAdvisor) => {
    if (isAdvisor) {
        return formatFartherAccountForAdvisors(account);
    }
    const { displayName, custodianAccountNumber } = account.accountDetails;
    if (custodianAccountNumber === null) {
        return displayName;
    }
    return `${displayName} (${custodianAccountNumber})`;
};
/**,
 * Format an AccountDetail object into a single line readable format.
 * @param {MiniAccountDetails} account - The account to format.
 * @return {string} The readable format. ex: <Account Name> - <Custodian> (<Custodian ID>)
 * If custodianAccountNumber === null
 * @return {string} <Account Name> - <Custodian>
 */
export const formatFartherAccountForAdvisors = (account) => {
    const { displayName, custodianAccountNumber, custodian } = account.accountDetails;
    if (custodianAccountNumber === null) {
        return `${displayName} - ${custodian}`;
    }
    return `${displayName} - ${custodian} (${custodianAccountNumber})`;
};
/**,
 * Format an AccountDetail object into a single line readable format.
 * @param {MiniAccountDetails} account - The account to format.
 * @return {string} The readable format. ex: <Account Type> (<Custodian ID>)
 */
export const formatFartherAccountType = (account, isAdvisor) => {
    if (isAdvisor) {
        return formatFartherAccountTypeForAdvisors(account);
    }
    const { accountType, custodianAccountNumber } = account.accountDetails;
    if (custodianAccountNumber === null) {
        return accountType;
    }
    return `${accountType} (${custodianAccountNumber})`;
};
/**,
 * Format an AccountDetail object into a single line readable format.
 * @param {MiniAccountDetails} account - The account to format.
 * @return {string} The readable format. ex: <Account Type> - <Custodian> (<Custodian ID>)
 */
export const formatFartherAccountTypeForAdvisors = (account) => {
    const { accountType, custodianAccountNumber, custodian } = account.accountDetails;
    if (custodianAccountNumber === null) {
        return `${accountType} - ${custodian}`;
    }
    return `${accountType} - ${custodian} (${custodianAccountNumber})`;
};
/**
 * Format an ExtendedAccount (extended external account) object into a single line readable format.
 * <Institution Name> - <Account Name> (...<Last Four>)
 * @param {ExtendedAccount} account - The account to format.
 * @return {string} The readable format. ex: Chase - Adam's Checking (...9239)
 */
export const formatExtendedExternalAccount = (account) => {
    const bankName = isManualAccount(account) || isManualAccountV1(account)
        ? (account.details?.bank?.name ?? null)
        : (account.details?.institution?.name ?? null);
    const accountType = getAccountType(account);
    const partialAccountNumber = getPartialAccountNumber(account);
    if (bankName === null) {
        return `${UNKNOWN_ACCOUNT} (...${partialAccountNumber})`;
    }
    return `${bankName} - ${accountType} (...${partialAccountNumber})`;
};
/**
 * Format an ExternalAccount object into a single line readable format.
 * <Institution Name> - <Account Name> (...<Last Four>)
 * @param {ExternalAccount} account - The account to format.
 * @return {string} The readable format. ex: Chase - Adam's Checking (...9239)
 */
export const formatExternalAccount = (account) => {
    if (isManualAccountV1(account) || isExtendedAccount(account)) {
        return formatExtendedExternalAccount(account);
    }
    if (isPlaidAccountExtended(account)) {
        const acc = account.details.account;
        const accountName = acc.name === "" ? capitalize(acc.accountType) : acc.name;
        const mask = acc.accountNumberMask ?? MASK_NUMBER;
        return `${account.institution.name} - ${accountName} (...${mask})`;
    }
    const accountName = account.name === "" ? capitalize(account.accountType) : account.name;
    const mask = isNil(account.mask) || account.mask === "" ? MASK_NUMBER : account.mask;
    if (account.institutionName === "") {
        return `${accountName} (...${mask})`;
    }
    return `${account.institutionName} - ${accountName} (...${mask})`;
};
//# sourceMappingURL=account.js.map